import type { TAuditLogRes } from 'api/swagger';
import type { IAuditEntityContext } from 'components/common/audit-logs/types.ts';
import { BaseAuditLogService } from './base-audit-log-service.ts';
import { ClientAuditLogService } from './client-audit-log-service.ts';
import { ClientInsuranceAuditLogService } from './client-insurance-audit-log-service.ts';
import { TripAuditLogService } from './trip-audit-log-service.ts';
import { TripTaskAuditLogService } from './trip-task-audit-log-service.ts';
import type { IAuditLogReferenceData, IAuditLogService } from './types.ts';

export const auditLogServiceFactory = (
  auditLog: TAuditLogRes,
  currentEntity?: IAuditEntityContext,
  referenceData?: IAuditLogReferenceData,
): IAuditLogService => {
  switch (auditLog.entityType) {
    case 'client':
      return new ClientAuditLogService(auditLog, currentEntity);
    case 'client_insurance':
      return new ClientInsuranceAuditLogService(auditLog, currentEntity);
    case 'trip':
      return new TripAuditLogService(auditLog, currentEntity, referenceData);
    case 'trip_task':
      return new TripTaskAuditLogService(auditLog, currentEntity, referenceData);
    default:
      return new BaseAuditLogService(auditLog, currentEntity, referenceData);
  }
};
